import FileSystemDebugScreen from '@/components/FileSystemDebugScreen';

export default function FileSystemDebugRoute() {
  return <FileSystemDebugScreen />;
}
